import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'up-feature-pagination',
  templateUrl: './feature-pagination.component.html',
  styleUrls: ['./feature-pagination.component.scss']
})
export class FeaturePaginationComponent implements OnInit {
  @Input() total: number;
  @Input() limit: number;
  @Input() newBrand: boolean;
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() limitChange: EventEmitter<any> = new EventEmitter<any>();

  formPagination!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
    this.changeLimit();
  }

  createForm(): void {
    this.formPagination = this.fb.group({
      limit: [this.limit]
    });
  }

  onChange(event: number): void {
    this.pageChange.emit(event);
  }

  changeLimit(): void {
    this.formPagination.get('limit').valueChanges.subscribe(res => {
      this.limitChange.emit(res);
    });
  }
}
